module.exports = __webpack_public_path__ + "img/1F972.9fa8c7fa.svg";